import AdminAssessmentsCrud from "./AdminAssessments.crud";

import useBackToConfirmation from './useBackToConfirmation'
import { useSelectAndTranscription, useSelectAndCutting, useSelectAndMarking } from './useSelectAndViewAssessment'

export default { useBackToConfirmation, useSelectAndTranscription, useSelectAndCutting, useSelectAndMarking }

export { AdminAssessmentsCrud }